import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import MessagesList from '../../components/List/Messages/MessagesList';
import MessagesFilter from '../../components/Filter/MessagesFilter';
import MessageModal from '../../components/Modal/MessageModal';
import { useDispatch, useSelector } from 'react-redux';
import { getChatList } from '../../redux/actions/chat/getChatList';
import { useForm } from 'react-hook-form';
import { Pagination } from 'antd';
import clsx from 'clsx';
import { getChatListStats } from '../../redux/actions/chat/getChatListStats';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { resetDeleteChatList, resetGetChatList, resetGetChatListStats } from '../../redux/slices/chat.slice';
import { socket } from '../../utils/socket';
import { store } from '../../redux/store';
import Swal from 'sweetalert2';
import { getMailingList } from '../../redux/actions/chat/getMailingList';

export default function ChatListPage({ isSelf }) {
  const tabs = [
    {
      label: 'Админ/Контрагент',
      type: 'staff_employer',
    },
    {
      label: 'Контрагент/Соискатель',
      type: 'employer_candidate',
    },

    {
      label: 'Админ/Соискатель',
      type: 'staff_candidate',
    },
    {
      label: 'Админ/Менеджер',
      type: 'staff_staff',
      subtype: 'admin_admin',
    },

    // {
    //   label: 'Админ/Менеджер',
    //   type: 'staff_staff',
    //   subtype: 'admin_manager',
    // },
    // {
    //   label: 'Менеджер/Менеджер',
    //   type: 'staff_staff',
    //   subtype: 'manager_manager',
    // },
    // {
    //   label: 'Тех. поддержка',
    //   type: 'support',
    // },
  ];
  const selfTabs = [
    {
      label: 'Контрагенты',
      type: 'staff_employer',
    },
    {
      label: 'Соискатели',
      type: 'staff_candidate',
    },
    {
      label: 'Менеджеры',
      type: 'staff_staff',
      subtype: 'admin_admin',
    },
    // {
    //   label: 'Менеджеры',
    //   type: 'staff_staff',
    //   subtype: 'admin_manager',
    // },
  ];
  const {
    getMe: { data: getMeData, error: getMeError, loading: getMeLoading },
  } = useSelector((state) => state.user);
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const {
    getChatList: { data: getChatListData, error: getChatListError, loading: getChatListLoading },
    getChatListStats: { data: getChatListStatsData, error: getChatListStatsError, loading: getChatListStatsLoading },
  } = useSelector((state) => state.chat);
  const { socketConnect } = useSelector((state) => state.app);
  useEffect(() => {
    return () => {
      dispatch(resetGetChatList());
      dispatch(resetGetChatListStats());
    };
  }, []);

  const [showModal, setShowModal] = useState(false);
  // const [currentPage, setCurrentPage] = useState(1);
  const [searchParams, setSearchParams] = useSearchParams();
  console.log(searchParams.get('type'));

  const formFilter = useForm({
    defaultValues: {
      prevType: null,
      page: 1,
      filter: {},
      type: { type: isSelf ? searchParams.get('type') ?? selfTabs[0]?.type : searchParams.get('type') ?? tabs[0]?.type },
    },
  });

  useEffect(() => {
    if (getMeData && socketConnect) {
      if (!searchParams.get('type')) {
        searchParams.set('type', isSelf ? selfTabs[0]?.type : tabs[0]?.type);
        setSearchParams(searchParams);
      }
      setTimeout(() => {
        formFilter.setValue('type', { type: isSelf ? searchParams.get('type') ?? selfTabs[0]?.type : searchParams.get('type') ?? tabs[0]?.type });
      }, 50);
    }
  }, [getMeData, socketConnect]);

  const formChecked = useForm({
    defaultValues: {
      userChecked: {},
    },
  });
  const userChecked = formChecked.watch('userChecked');
  const type = formFilter.watch('type');
  const currentPage = formFilter.watch('page');
  const filterWatch = formFilter.watch('filter');
  const hasVacancyWatch = formFilter.watch('filter.has_vacancy');
  const navigate = useNavigate();
  // useEffect(() => {
  //   if (getChatListData) {
  //     let candidateChecked = {};
  //     getChatListData?.results?.map((cand) => {
  //       candidateChecked = { ...candidateChecked, [cand.id]: true };
  //     });
  //     formChecked.setValue('userChecked', candidateChecked);
  //   }
  // }, [getChatListData]);
  const getSubscribeBody = (val) => {
    return {
      chat_types: [val, { type: 'support' }],
      include_all: val.type !== 'staff_staff',
      ...(val.type == 'staff_staff' && { chat_subtype: val.subtype }),
    };
  };

  const {
    deleteChatList: { data: deleteChatListData, error: deleteChatListError, loading: deleteChatListLoading },
  } = useSelector((state) => state.chat);
  useEffect(() => {
    if (deleteChatListData) {
      Swal.fire({
        title: 'Сообщения удалена!',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      formChecked.setValue('userChecked', {});
      formFilter.setValue('filterTouch', true);
      dispatch(resetDeleteChatList());
    }
  }, [deleteChatListData]);

  React.useEffect(() => {
    if (getMeData && socket.connected) {
      const subscription = formFilter.watch((value, { name, type }) => {
        if (name == 'type') {
          if (socket.connected) {
            if (value.prevType) {
              socket.off('chat_message_sent');
              socket.off('chat_created');
              socket.emit('unsubscribe_chats', getSubscribeBody(value.prevType), (response) => {
                console.log('unsubscribe');
                console.log(response);
              });
            }
            console.log(getSubscribeBody(value.type));

            socket.emit('subscribe_chats', getSubscribeBody(value.type), (response) => {
              console.log(response);
            });
            socket.on('chat_created', (data) => {
              onFetch(value.page, value.type, value.filter, true);
            });
            socket.on('chat_deleted', (data) => {
              console.log('created', data);
            });
            socket.on('chat_message_sent', (data) => {
              onFetch(value.page, value.type, value.filter);
            });
            formFilter.setValue('prevType', value.type);
          }
          onFetch(value.page, value.type, value.filter, true);
        } else if (name == 'page') {
          onFetch(value.page, value.type, value.filter);
        } else if (name == 'filterTouch' && value.filterTouch) {
          onFetch(value.page, value.type, value.filter, true);

          formFilter.setValue('filterTouch', false);
        }
      });
      return () => subscription.unsubscribe();
    }
  }, [formFilter.watch, socket.connected, getMeData]);

  const onFetch = (page, type, filter = {}, fetchStats) => {
    if (fetchStats) {
      dispatch(getChatListStats(isSelf ? { user_id: getMeData?.id, ...filter } : { ...filter, ...(filter?.has_vacancy ? { has_vacancy: true } : { has_vacancy: undefined }) }));
    }
    dispatch(getChatList({ ...(isSelf ? { user_id: getMeData?.id } : {}), page, ...(type?.type == 'staff_employer' ? { type: ['staff_employer', 'support'] } : type), ...filter, ...(filter?.has_vacancy ? { has_vacancy: true } : { has_vacancy: undefined }) }));
  };
  useEffect(() => {
    if (getMeData) {
      dispatch(getChatListStats(isSelf ? { user_id: getMeData?.id, ...filterWatch } : { ...filterWatch }));
    }
  }, [getMeData]);

  // useEffect(() => {
  //   if (!isSelf) {
  //     dispatch(getChatList({ as_observer: true, page: currentPage, ...type }));
  //   }
  // }, [currentPage]);

  // useEffect(() => {
  //   if (isSelf && getMeData) {
  //     dispatch(getChatList({ user_id: getMeData?.id, page: currentPage, ...type }));
  //   }
  // }, [currentPage, getMeData]);

  return (
    <div className="mx-auto flex flex-1 flex-col w-full max-w-[1163px]">
      <div className="w-full mt-6 p-2">
        <div className="flex flex-row justify-between gap-1">
          <div className="flex items-center gap-2">
            <ul className=" flex list-none gap-3 border-b border-gray-200 justify-start items-baseline flex-wrap text-2xl">
              <li
                key={'1'}
                onClick={() => {
                  navigate('/chats');
                }}
                className={`cursor-pointer hover:text-[#00B2A4] pb-1 ${pathname == '/chats' ? 'font-bold text-[#00B2A4]' : 'border-b-1 border-[#00B2A4] border-dotted '}`}>
                Чаты
              </li>
              <li
                key={'2'}
                onClick={() => {
                  navigate('/messages');
                }}
                className={`cursor-pointer hover:text-[#00B2A4] pb-1 ${pathname == '/messages' ? 'font-bold text-[#00B2A4]' : 'border-b-1 border-[#00B2A4] border-dotted '}`}>
                Мои сообщения
              </li>{' '}
              <li
                key={'3'}
                onClick={() => {
                  navigate('/mailing');
                }}
                className={`cursor-pointer hover:text-[#00B2A4] pb-1 ${pathname == '/mailing' ? 'font-bold text-[#00B2A4]' : 'border-b-1 border-[#00B2A4] border-dotted '}`}>
                Рассылка
              </li>
            </ul>{' '}
          </div>

          <p className="flex flex-wrap justify-center items-center">
            <div>
              {isSelf && (
                <button
                  type="button"
                  className="text-center border rounded py-2 px-2 text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300"
                  onClick={() => {
                    setShowModal(true);
                  }}>
                  Новое сообщение
                </button>
              )}
            </div>
          </p>
        </div>
      </div>
      <div className="w-full flex flex-col first:flex-row zero:justify-evenly">
        <div className="flex w-full flex-col zero:w-[80%] p-2">
          <ul className=" flex list-none gap-3 border-b border-gray-200 justify-start items-baseline flex-wrap">
            {(isSelf ? selfTabs : tabs)?.map((item) => (
              <li
                key={item?.type}
                onClick={() => {
                  formFilter.setValue('filter', { has_vacancy: item?.type == 'staff_employer' ? formFilter.getValues('filter.has_vacancy') : undefined });
                  searchParams.set('type', item?.type);
                  setSearchParams(searchParams);
                  formFilter.setValue('type', { type: item?.type });
                }}
                className={`cursor-pointer hover:text-[#00B2A4] pb-1 ${type.type === item.type ? 'font-bold text-[#00B2A4]' : 'border-b-1 border-[#00B2A4] border-dotted '}`}>
                {item?.label}
                {
                  <>
                    &nbsp;
                    {getChatListStatsLoading && !getChatListStatsData ? (
                      <Skeleton width={'20.6px'} height={'19px'} className="translate-y-[-2px]" />
                    ) : (
                      <>
                        (
                        {item?.type == 'staff_employer'
                          ? getChatListStatsData?.['staff_employer']?.messages + getChatListStatsData?.['support']?.messages
                          : item?.type == 'employer_candidate'
                          ? getChatListStatsData?.['employer_candidate']?.chats
                          : item?.type == 'staff_staff' && !isSelf && getChatListStatsData?.['staff_staff']
                          ? getChatListStatsData?.['staff_staff']?.chats
                          : getChatListStatsData?.[item?.type]?.messages}
                        )
                      </>
                    )}
                  </>
                }
              </li>
            ))}
          </ul>
          <div className={'mt-3'}>
            <div
              className={clsx('flex flex-col w-full border-1 border-[#C4C4C4] shadow-lg rounded-md', 'p-6')}
              // isSelf ? 'pb-3' : 'p-6'
            >
              {getChatListData?.results?.length ? (
                <>
                  <MessagesList currentItems={getChatListData?.results} check isSelf={isSelf} form={formChecked} />
                  <Pagination
                    className="flex items-center justify-center mt-4"
                    defaultCurrent={currentPage}
                    total={getChatListData?.count}
                    showSizeChanger={false}
                    current={currentPage}
                    disabled={getChatListLoading}
                    onChange={(e) => {
                      formFilter.setValue('page', e);
                    }}
                  />
                </>
              ) : (
                <div className="relative h-[432px]">
                  {' '}
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-xl opacity-50 font-bold">Чатов нет</div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className=" justify-start zero:w-[20%] xs:w-[30%] first:flex zero:p-1 xs:p-4 flex-col " style={{ paddingTop: '49px' }}>
          <MessagesFilter type={type.type} form={formFilter} isSelf={isSelf} />
        </div>
      </div>
      <MessageModal
        open={showModal}
        onCancel={() => {
          setShowModal(false);
        }}
      />
    </div>
  );
}
